import { useState, useEffect } from "react";
import iconImage from '../images/ic_nobg.png';
import androidIconImage from '../images/Android_logo.png';
import alexaImage from '../images/alexa.jpg';
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const GeneralHome = () => {

  const currentMainThemeColor = localStorage.getItem("currentMainThemeColor") ?? "#135c13";
  const currentSecondaryThemeColor = localStorage.getItem("currentSecondaryThemeColor") ?? "#cfcfcf";

  const styles = {
    pageTitle: {
      padding: '2rem 1rem',
      marginBottom: '2rem',
      backgroundColor: currentSecondaryThemeColor, 
      borderRadius: '0.3rem',
      height: 380,
      display: 'flex',
      justifyContent: 'center',
    },
  }

  const [showImage, setShowImage] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(() => setShowImage(false), 4000);
  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when animation starts
    // Disable scrolling when animation starts
    document.body.style.overflow = "hidden";

    // Re-enable scrolling after animation ends
    const timer = setTimeout(() => {
      setShowImage(false);
      document.body.style.overflow = "auto";
    }, 2250); 

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "auto"; // Ensure scrolling is restored
    };
  }, []);

  return (
    <div className="container">
      {/* Animated Image Slices */}
      {showImage && (
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 50 }}>
          {/* Left Half */}
          <motion.div
            initial={{ x: 0, opacity: 1 }}
            animate={{ x: "-120%", opacity: 0 }}
            transition={{ delay: 0.5, duration: 2, ease: "easeInOut" }}
            className="w-1/2 h-full"
            style={{ position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: currentSecondaryThemeColor,  backgroundSize: "cover", backgroundPosition: "left", width: '100%', height: '100%' }}
          >
            <img src={iconImage} alt="iconImage" style={{width: 450, height: 400}} />
          </motion.div>
          {/* Right Half */}
          <motion.div
            initial={{ x: 0, opacity: 1 }}
            animate={{ x: "120%", opacity: 0 }}
            transition={{ delay: 0.5, duration: 2, ease: "easeInOut" }}
            className="w-1/2 h-full"
            style={{ position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: currentSecondaryThemeColor, backgroundSize: "cover", backgroundPosition: "right", width: '100%', height: '100%' }}
          >
            <img src={iconImage} alt="iconImage" style={{width: 450, height: 400}} />
          </motion.div>
        </div>
      )}
      <header style={styles.pageTitle}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <img src={iconImage} alt="iconImage" style={{width: 350, height: 300}} />
          <h1>{'Landlord Automations'}</h1>
        </div>
      </header>
      <div>
        <p style={{fontFamily: 'Comic Sans MS', fontSize: 22}}>
          Welcome to <strong>Landlord Automations</strong>, where innovation meets connectivity. As a startup in the Internet of Things industry, we are committed to expanding the horizons of smart technology by constantly integrating new devices into our interconnected ecosystem. Our mission is to seamlessly blend cutting-edge advancements with everyday functionality, transforming how you interact with the world around you. From smart homes, farms automation and beyond, we strive to enhance your life through an ever-growing fleet of intelligent, responsive, and efficient devices. Join us in shaping a smarter future, one connection at a time.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <img src={androidIconImage} alt="androidIconImage" style={{width: 350, height: 350}} />
          <p style={{fontFamily: 'Comic Sans MS', fontSize: 22}}>{'An android app is already available to control your devices'}</p>
          <a href={"https://play.google.com/store/apps/details?id=com.home_controller&hl=en_CA"} className="nav-link">
            Download android app
          </a>
          <img src={alexaImage} alt="alexaImage" style={{width: 500, height: 350}} />
          <p style={{fontFamily: 'Comic Sans MS', fontSize: 22}}>{'We also offer integration with Amazon\'s alexa!'}</p>
          <Link to={"/alexaprivacy"} className="nav-link">
            Privacy policy
          </Link>
          <p style={{fontFamily: 'Comic Sans MS', fontSize: 22}}>
          New features will be available in the next few months! stay tuned for more!
        </p>
        </div>
        
      </div>
    </div>
  );
};

export default GeneralHome;
